import { createFileRoute } from '@tanstack/react-router'
import { SettingTimeWorking } from '@/components/settings-route/time-working'

export const Route = createFileRoute('/_auth/settings/time-working')({
  component: SettingTimeWorking,
})
